var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReportSimilarity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.67 5.5L19.5 10.33V19.5H5.5V5.5H14.67ZM14.67 3.5H5.5C4.4 3.5 3.5 4.4 3.5 5.5V19.5C3.5 20.6 4.4 21.5 5.5 21.5H19.5C20.6 21.5 21.5 20.6 21.5 19.5V10.33C21.5 9.8 21.29 9.29 20.91 8.92L16.08 4.09C15.71 3.71 15.2 3.5 14.67 3.5ZM7.5 15.5H17.5V17.5H7.5V15.5ZM7.5 11.5H17.5V13.5H7.5V11.5ZM7.5 7.5H14.5V9.5H7.5V7.5Z",
    fill: "#240D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportSimilarity);
export default __webpack_public_path__ + "static/media/icon_report_similarity.d3a88bc4162351d36296ee72dfbc2e3d.svg";
export { ForwardRef as ReactComponent };